import { userHasConsentedToCookieCategoryWithKey } from 'src/cookies/consent-cookie';

const marketingConsentCookieCategoryKey = 'marketing';

export const userHasConsentedToMarketingCookieCategory = (): boolean =>
  userHasConsentedToCookieCategoryWithKey(marketingConsentCookieCategoryKey);
